import { render, staticRenderFns } from "./RowSideForm.vue?vue&type=template&id=81f10a86&scoped=true&"
import script from "./RowSideForm.vue?vue&type=script&lang=js&"
export * from "./RowSideForm.vue?vue&type=script&lang=js&"
import style0 from "./RowSideForm.vue?vue&type=style&index=0&id=81f10a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f10a86",
  null
  
)

export default component.exports